function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children } from 'react';
import { bool, func, node, object, shape, string } from 'prop-types';
import clsx from 'clsx';
import SovosEditableDrawer from '../sovos-editable-drawer';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';
const SovosFilterDrawer = _ref => {
  let {
    children,
    className,
    ClearButtonProps,
    onClose,
    open,
    SaveButtonProps,
    style,
    title,
    ...rest
  } = _ref;
  const {
    t
  } = useMosaicTranslation();
  const isDisabled = () => {
    const realValues = [];
    Children.forEach(children, item => {
      if (item.props.data !== undefined && item.props.data !== null && item.props.data.length !== 0) {
        realValues.push(item.props.data);
      }
      return realValues;
    });
    return realValues.length < 1;
  };
  return /*#__PURE__*/React.createElement(SovosEditableDrawer, _extends({
    className: clsx('sovosFilterDrawer', className),
    onClose: onClose,
    open: open,
    PrimaryButtonProps: {
      children: SaveButtonProps.children,
      className: 'sovosFilterDrawer__saveButton',
      disabled: isDisabled() || SaveButtonProps.disabled,
      onClick: SaveButtonProps.onClick
    },
    SecondaryButtonProps: {
      children: ClearButtonProps.children || t('clear'),
      className: 'sovosFilterDrawer__clearButton',
      disabled: isDisabled() || ClearButtonProps.disabled,
      onClick: ClearButtonProps.onClick
    },
    style: style,
    title: title || t('filterDrawer.title')
  }, rest), children);
};
SovosFilterDrawer.propTypes = {
  /**
   * The content of the filter drawer. Children should be a combination of
   * `SovosFilterCheckboxList`, `SovosFilterDateInput`,
   * `SovosFilterDrawerSection`, `SovosFilterDateRange`,
   * `SovosFilterNumberRange`, and `SovosFilterTextEntry`
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Props applied to the Clear button
   */
  ClearButtonProps: shape({
    onClick: func.isRequired,
    children: node,
    disabled: bool
  }).isRequired,
  /**
   * Callback for when the drawer is closed by clicking off of it
   */
  onClose: func.isRequired,
  /**
   * The drawer's open state
   */
  open: bool.isRequired,
  /**
   * Props applied to the Apply button
   */
  SaveButtonProps: shape({
    onClick: func.isRequired,
    disabled: bool,
    children: node
  }).isRequired,
  /**
   * Title content
   */
  title: node,
  /**
   * Inline styles applied to the root element
   */
  style: object
};
export default SovosFilterDrawer;